<template lang="pug">
  div    
    v-layout.my-6(v-if="isFetching")
      v-row.fill-height.ma-0(align='center' justify='center')
        v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

    .content-layout(v-else)
      v-layout.mt-4(v-if="settings.id")
        y-checkbox.mt-1(v-model="settings.enabled" hide-details dense :disabled="!settings.id" @change="updateInstallmentAsDefault") 
          template(v-slot:label) 
            div.p1.default--text {{ $t('enable_for_all_invoices') }}
      v-layout.mt-2   
        v-col.text-right
          v-btn.my-auto.ml-2.button-Aa-small.info500--text(color='white' depressed small height=20 @click="showUpdateSettings = true")
            eva-icon(height=15 width=15 name ="edit-outline" :fill="$vuetify.theme.themes[$theme].info500" style="margin-top:2px;")
            div.ml-1.mr-n1 {{ $t('edit') }}
      v-card.mt-3(outlined)
        v-layout.pb-1.basic200
          div.px-3.mt-4.mb-2.s2.primary400--text {{ $t('amount_range') }}
          v-spacer
          div.px-3.mt-4.mb-2.s2.primary400--text {{ $t('min_payment') }}
        div(v-for="(option, index) in settings.minimum_payment" :key="index")
          v-divider
          v-layout.px-3
            div.py-4.p2.default--text {{ `${$currency.symbol} ` + ((index == 0) ? 0 : settings.minimum_payment[index - 1].max/$currency.multiplier) + ` - ${$currency.symbol} ` + settings.minimum_payment[index].max/$currency.multiplier}}
            v-spacer
            div.py-4.p2.default--text {{ option.value | displayPrice }}
      v-card.mt-3(outlined)
        v-layout.py-2.px-3
          div.py-4.p2.default--text {{ $t('payment_period') }}
          v-spacer
          div.py-4.p2.default--text {{ settings.deadline || 0 }} {{ $t('days') }}

    .modals
       y-dialog(v-model='showUpdateSettings', max-width='600' persistent scrollable)
          v-card
            v-card-title.px-5.white.py-4
              v-row(no-gutters)
                v-col
                  p.mb-0.h6.basic800--text {{ $t('partial_payment_settings') }}
            v-divider.basic300
            v-card-text.px-4
              v-form(ref="form")
                div.s1.basic1000--text.pt-6.pa-0.ma-0 {{ $t('set_payment_options') }}
                template(v-for="(option, index) in paymentOptions")
                  v-row.mt-3.mx-1
                    v-col.pa-0(cols="8")
                      p.my-1.label.basic600--text.text-uppercase.mt-2 {{ $t('range_amount') }}
                      v-text-field.mr-0.p1(solo flat   height="40" background-color="basic200" v-model='paymentOptions[index].max' :label="$t('range.label')" :placeholder="$t('range.placeholder')" outlined dense type="number" :rules="getRules((index == 0) ? 0 : paymentOptions[index - 1].max)" :prefix="$currency.symbol+ ' ' + ((index == 0) ? 0 : paymentOptions[index - 1].max) + ' - '+ $currency.symbol + ' '" :disabled="paymentOptions.length - 1 > index" hide-details)
                    v-col.pa-0.ml-1
                      p.my-1.label.basic600--text.text-uppercase.mt-2 {{ $t('min_payment') }}
                      v-text-field.ml-1.p1(solo flat   height="40" background-color="basic200" v-model='paymentOptions[index].value' :label="$t('price.label')" :placeholder="$t('price.placeholder')" outlined dense type="number" :rules="rules.not_empty" :prefix="$currency.symbol" hide-details)
                  v-row.mx-1
                    v-col.pa-0.shrink
                      v-btn.my-4.button-AA-tiny.text-uppercase(color="danger" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].dangerT08}" v-if="index == (paymentOptions.length - 1) && index != 0" size=24  @click="paymentOptions.splice(paymentOptions.length - 1, 1)")
                        | - {{ $t('delete_option') }}
                    v-col.pa-0.ml-2
                      v-btn.my-4.button-AA-tiny.text-uppercase(color="textColorAccent" outlined x-small height="24" :style="{'background-color': $vuetify.theme.themes[$theme].infoT08}" v-show="index == (paymentOptions.length - 1)" size=24  @click="paymentOptions.push({ max: null, value: null })" v-if="paymentOptions[index].max > 0")
                        | + {{ $t('add_option') }}

                p.mt-6.s1.basic1000--text {{ $t('set_payment_period') }}
                v-select.mt-4.p1(solo flat   height="40" background-color="basic200" v-model='deadlineSelection' :label="$t('period.label')" :placeholder="$t('period.placeholder')" return-object item-text="title" outlined dense :rules="rules.selected" :items="daySelections" @change="setDefaultDeadlineValue" hide-details)

                .others(v-if="deadlineSelection && deadlineSelection.value == 0")
                  v-text-field.mb-n6.mt-3.p1(solo flat   height="40" background-color="basic200" v-model='defaultDeadline' :label="$t('day.label')" :placeholder="$t('day.placeholder')" outlined dense type="number" suffix="days" :rules="rules.not_empty")
            v-card-actions
              v-spacer
              v-btn.pa-4.button-AA-small(color='primary400', text='', @click='showUpdateSettings = false')
                | {{ $t('cancel') }}
              v-btn.button-AA-medium.mr-2.white--text.pa-2(color='info500' depressed height=32 @click='clickSave' :loading="isLoading")
                | {{ $t('update') }}
          

</template>

<script>
import { mapActions } from 'vuex'
export default {
  name: 'InstallmentSettings',
  props: ['company'],
  data: (v) => ({
    isFetching: true,
    showUpdateSettings: false,
    minimumPayment: 0,
    defaultDeadline: null,
    paymentOptions: [
      {
        max: null,
        value: null
      }
    ],
    deadlineSelection: null,
    daySelections: [
      { 
        title: v.$t('one_week'),
        value: 7
      },
      { 
        title: v.$t('one_month'),
        value: 30
      },
      { 
        title: v.$t('three_month'),
        value: 90
      },
      { 
        title: v.$t('other'),
        value: 0
      }
    ],
    settings: {
      id: null,
      enabled: false,
      minimum_payment: [],
      deadline: null,
      company: v.company.id,
    },
    rules: {
      not_empty: [
        val => val != null || 'This field is required',
        val => val > 0 || 'This field is required'
      ],
      selected: [(v) => !!v || 'This field is required', (v) => v != 0|| 'This field is required']
    },
    isLoading: false
  }),
  mounted () {
    this.fetchSettings()
  },
  watch: {
    settings: {
      handler(val){
        this.paymentOptions = []
        val.minimum_payment.forEach(option => {
          const newOptions = {
            max: option.max/this.$currency.multiplier,
            value: option.value/this.$currency.multiplier
          }
          this.paymentOptions.push(newOptions)
        })

        this.deadlineSelection = { 
          title: 'Others',
          value: 0
        }
        this.defaultDeadline = val.deadline
        const selectedTypes = this.daySelections.filter((obj) => {
          return obj.value == this.defaultDeadline
        })
        const selectedType = selectedTypes[0]
        if (selectedType) {
          this.deadlineSelection = selectedType
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    getRules (minAmount) {
      return [
        v => !!v || 'Amount is required',
        v => v != 0|| 'Amount is required',
        v => v >= parseInt(minAmount) || `Amount should be above RM ${minAmount}`,
      ]
    },
    setDefaultDeadlineValue () {
      if (this.deadlineSelection && this.deadlineSelection.value) {
        this.defaultDeadline = this.deadlineSelection.value
      }
    },
    updateInstallmentAsDefault() {
      this.axios.patch(`/installment_settings/${this.settings.id}/`, { enabled : this.settings.enabled})
        .then(resp => {
          this.settings = resp.data
          this.$emit('activated', this.settings.enabled)
        })
        .catch(() => {
          this.settings.enabled = !this.settings.enabled
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
    },
    openTrackerDialog (type) {
      this.openTrackerType = type
      this.showUpdateTrackersDialog = true
    },
    fetchSettings () {
      this.$axios.get(`/installment_settings/?company=${this.company.id}`).then((response) => {
        if (response.data.results.length != 0) {
          this.settings = response.data.results[0]
        }
      })
      .catch(() => {})
      .finally(() => {
        this.isFetching = false
      })
    },
    clickSave () {
      if (!this.$refs.form.validate()) {
        return
      }
      this.isLoading = true
      this.settings.minimum_payment = []
      this.paymentOptions.forEach(option => {
        const newOptions = {
          max: parseInt((parseFloat(option.max)).toFixed(this.$currency.exponent).replace('.', '')),
          value: parseInt((parseFloat(option.value)).toFixed(this.$currency.exponent).replace('.', ''))
        }
        this.settings.minimum_payment.push(newOptions)
      })
      this.settings.deadline = this.defaultDeadline
      if (this.settings.id) {
        this.axios.put(`/installment_settings/${this.settings.id}/`, this.settings)
        .then(resp => {
          this.settings = resp.data
          this.showUpdateSettings = false
          this.$emit('activated', this.settings.enabled)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
        return
      }
      this.axios.post(`/installment_settings/`, this.settings)
        .then(resp => {
          this.settings = resp.data
          this.showUpdateSettings = false
          this.$emit('activated', this.settings.enabled)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}

.v-card--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>

<i18n>
{
  "en": {
    "enable_for_all_invoices": "Enable this by default for all invoices",
    "amount_range": "Amount Range",
    "min_payment": "Min Payment",
    "payment_period": "Payment period",
    "days": "days",
    "partial_payment_settings": "Partial Payment Settings",
    "set_payment_options": "Set payment options",
    "range_amount": "Range Amount",
    "range": {
      "label": "Range amount",
      "placeholder": "0"
    },
    "price": {
      "label": "Minimum payment",
      "placeholder": "0"
    },
    "period": {
      "label": "Period",
      "placeholder": "Select installment period"
    },
    "day": {
      "label": "Period",
      "placeholder": "0"
    },
    "add_option": "Add Option",
    "delete_option": "Delete Option",
    "set_payment_period": "Set payment period",
    "min_payment": "Min Payment"
  },
  "id": {
    "enable_for_all_invoices": "Aktifkan ini secara default untuk semua bukti pembayaran",
    "amount_range": "Rentang jumlah",
    "min_payment": "Pembayaran min",
    "payment_period": "Tempo pembayaran",
    "days": "hari",
    "partial_payment_settings": "Pengaturan Pembayaran Cicil",
    "set_payment_options": "Atur Pembayaran",
    "range_amount": "Rentang jumlah",
    "range": {
      "label": "Rentang jumlah",
      "placeholder": "0"
    },
    "price": {
      "label": "Pembayaran min",
      "placeholder": "0"
    },
    "period": {
      "label": "Jangka",
      "placeholder": "Atur Jangka Pembayaran"
    },
    "day": {
      "label": "Jangka",
      "placeholder": "0"
    },
    "add_option": "TAMBAH PILIHAN",
    "delete_option": "Hapus pilihan",
    "set_payment_period": "Atur Jangka Pembayaran",
    "min_payment": "Pembayaran minimum"
  }
}
</i18n>
